import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=1cb83410&scoped=true&"
import script from "./plans.vue?vue&type=script&lang=ts&"
export * from "./plans.vue?vue&type=script&lang=ts&"
import style0 from "./plans.vue?vue&type=style&index=0&id=1cb83410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb83410",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlansNavigation: require('/home/vsts/work/1/s/frontend/components/plans-navigation.vue').default,Toast: require('/home/vsts/work/1/s/frontend/components/notification/toast.vue').default,SystemDialog: require('/home/vsts/work/1/s/frontend/components/system-dialog.vue').default,SessionManagementNotification: require('/home/vsts/work/1/s/frontend/components/session-management-notification.vue').default,PersistentNotification: require('/home/vsts/work/1/s/frontend/components/persistent-notification.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
